import styled from '@emotion/styled';
import Image from 'presentations/views/components/atoms/Image';
import { white } from 'presentations/views/styles/color';
import { spacing, mediaMax } from 'presentations/views/styles';

interface Props {
  content: string;
}

export default function Component(props: Props) {
  return (
    <Container>
      <Left>{props.content}</Left>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: ${white};
  ${mediaMax.tablet} {
    flex-direction: column;
  }
`;
const Left = styled.div`
  padding: ${spacing(48)};
  ${mediaMax.tablet} {
    padding: ${spacing(24)};
  }
`;
const Right = styled.div`
  padding: ${spacing(48)};
  ${mediaMax.tablet} {
    padding: ${spacing(24)};
  }
  img {
    ${mediaMax.tablet} {
      max-width: 240px;
      width: 80%;
    }
  }
`;
